import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";

function ChatListMenu(props) {
  const [showMenu, setShowMenu] = useState(false);

  const handleMouseEnter = () => {
    setShowMenu(!showMenu);
  };

  const handleClose = () => {
    setShowMenu(false);
  };

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleClose} className={`chatlist-menu-options ${props.isHovered == props.chatId ? `` : `d-none`}`}>
      <FontAwesomeIcon icon={faEllipsisH} />
      <Dropdown.Menu show={showMenu} style={{ marginLeft: "-100px" }}>
        <Dropdown.Item onClick={() => props.handleEditChatlist(props.chatId)}>Edit</Dropdown.Item>
        <Dropdown.Item onClick={() => props.handleDeleteChatlist(props.chatId)}>Delete</Dropdown.Item>
      </Dropdown.Menu>
    </div>
  );
}

export default ChatListMenu;
